// extracted by mini-css-extract-plugin
export default {"tableContainer":"TableManageClients_tableContainer__53r8L","table":"TableManageClients_table__G9UD6"};